import useToast from "../../../../hooks/useToast";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { MaxOmissionsSetting, OmissionModuleText } from "./OmissionsModule-Types";
import { countSelectedByCategory, handleCheckboxChange, isOmissionDisabled } from "./omissionsUtils";
export const useOmissions = (sequenceNumber) => {
    var _a, _b, _c;
    // We use the store context here with the logic, rather than in the component itself.
    const { store, dispatch } = useOrderFlow();
    const { OmissionsToDisplay } = store.model.OmissionConfig;
    // Find the specific module and cast it to a extended interface. This is safe,
    // because we know we will only get the module we want.
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((mod) => mod.ModuleName === "Omission" && mod.Sequence === sequenceNumber && mod.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    // Get the specific config data from the module.
    const { NoCategoryText, useAccordions, defaultExpanded, CenterCards, MaximumOmissionsSettings, SoftMaxValue, SoftWarningText, HardMaxValue, HardWarningText, } = moduleConfig;
    // Only display when the category has a list of associated dislikes.
    const omissions = OmissionsToDisplay.filter((category) => !!category.dislikes.length);
    // Return the cart's omissions.
    let storeCartOmissions = store.cart.omissions;
    // Get recipe type for filtering dislikes
    const recipeType = store.cart.recipeType;
    // Hide any dislikes that are invalid for selected recipe type
    if (recipeType && !recipeType.isAllRecipeType) {
        storeCartOmissions = storeCartOmissions.filter((omission) => omission.AllowedRecipeTypes.map((allowed) => allowed.recipeTypeId).includes(recipeType.recipeTypeId));
    }
    // Returns a dictionary object in which the key is the categoryId and the value is the number of selections from that category.
    const selectionsByCategory = countSelectedByCategory(storeCartOmissions);
    // Check for the total number of omissions in the cart.
    const checkedCount = (_c = (_b = store === null || store === void 0 ? void 0 : store.cart) === null || _b === void 0 ? void 0 : _b.omissions) === null || _c === void 0 ? void 0 : _c.length;
    // Accordion configurations.
    const accordionProps = {
        defaultExpanded: defaultExpanded,
        disabled: false,
        chipText: !!(useAccordions === null || useAccordions === void 0 ? void 0 : useAccordions.TextValue) ? useAccordions.TextValue : OmissionModuleText.NUMBER_SELECTED,
    };
    const toast = useToast();
    return {
        accordionProps,
        handleCheckboxChange: handleCheckboxChange(OmissionsToDisplay, dispatch, storeCartOmissions, toast, MaximumOmissionsSettings, SoftMaxValue, SoftWarningText, HardMaxValue, HardWarningText, checkedCount),
        isOmissionDisabled: isOmissionDisabled(OmissionsToDisplay, MaximumOmissionsSettings === MaxOmissionsSetting.HARD || MaximumOmissionsSettings === MaxOmissionsSetting.BOTH, HardMaxValue, checkedCount, storeCartOmissions),
        NoCategoryText,
        omissions,
        selectionsByCategory,
        storeCartOmissions,
        accordionDisplay: !!useAccordions && omissions.length > 1,
        CenterCards,
        recipeType,
        cardsPerRow: {
            XS: moduleConfig.ScreenXS,
            SM: moduleConfig.ScreenSM,
            MD: moduleConfig.ScreenMD,
            LG: moduleConfig.ScreenLG
        }
    };
};
